import { render, staticRenderFns } from "./TheProtocolEditor.vue?vue&type=template&id=70403fd8&"
import script from "./TheProtocolEditor.vue?vue&type=script&lang=js&"
export * from "./TheProtocolEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports